import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "AppFooterContentWidget" */ './AppFooterContentWidget'),
  modules: ['./AppFooterContentWidget'],
  loading: () => <div />
});

export default LoadableWidget;
